import { render, staticRenderFns } from "./ShareRolesDialog.vue?vue&type=template&id=1d3eb752&"
import script from "./ShareRolesDialog.vue?vue&type=script&lang=js&"
export * from "./ShareRolesDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShareRolesDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports